/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignableUsersListView } from '../models/AssignableUsersListView';
import type { TaskCreateRequest } from '../models/TaskCreateRequest';
import type { TaskPatchRequest } from '../models/TaskPatchRequest';
import type { TaskSingleOkView } from '../models/TaskSingleOkView';
import type { TasksListOkView } from '../models/TasksListOkView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TasksService {
    /**
     * List tasks
     * Tasks for the authenticated seller: user-created (custom) and Listing Inspector ones. Optional shop and source filters.
     * @param shopIds Comma-separated shop UUIDs; scopes inspector tasks. Custom tasks are always returned.
     * @param limit Max 500
     * @param source Filter by task source
     * @returns TasksListOkView Task list
     * @throws ApiError
     */
    public static getAppTasksList(
        shopIds?: string,
        limit: number = 200,
        source?: 'listing_inspector' | 'custom',
    ): CancelablePromise<TasksListOkView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/tasks',
            query: {
                'shopIds': shopIds,
                'limit': limit,
                'source': source,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a custom task
     * @param requestBody
     * @returns TaskSingleOkView Created task
     * @throws ApiError
     */
    public static postAppTasksCreate(
        requestBody: TaskCreateRequest,
    ): CancelablePromise<TaskSingleOkView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/tasks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * List account members assignable to tasks
     * Owner plus every sub-user of the effective account. Client-side search only.
     * @returns AssignableUsersListView Assignable members
     * @throws ApiError
     */
    public static getAppTasksAssignableUsers(): CancelablePromise<AssignableUsersListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/tasks/assignable-users',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get one task
     * @param taskId
     * @returns TaskSingleOkView Task
     * @throws ApiError
     */
    public static getAppTaskGet(
        taskId: string,
    ): CancelablePromise<TaskSingleOkView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/tasks/{taskId}',
            path: {
                'taskId': taskId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not found`,
            },
        });
    }
    /**
     * Delete a task
     * Deletes any task the seller owns. Note: an inspector task re-appears if the seller swipes improve on that product again.
     * @param taskId
     * @returns any Deleted
     * @throws ApiError
     */
    public static deleteAppTaskDelete(
        taskId: string,
    ): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/tasks/{taskId}',
            path: {
                'taskId': taskId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update a task
     * Status is editable for any task. Title/description are editable for custom tasks only (400 otherwise).
     * @param taskId
     * @param requestBody
     * @returns TaskSingleOkView Updated task
     * @throws ApiError
     */
    public static patchAppTaskPatch(
        taskId: string,
        requestBody: TaskPatchRequest,
    ): CancelablePromise<TaskSingleOkView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v2/api/tasks/{taskId}',
            path: {
                'taskId': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                404: `Not found`,
            },
        });
    }
}
